<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Generate Po from Fp Pro'"
    :btn-loading="loading"
  >
    <template slot="header">
      <span>Enter work order to generate Po from Fp Pro</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col>
          <v-text-field
            v-model="workOrder"
            type="number"
            :rules="[(v) => !!v || 'Work Order is required']"
          >
            <template slot="label">
              Work Order<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="(job && job.reference && job.reference.includes('REVISED')) || remakeReasonId">
        <v-col>
          <v-select
            v-model="remakeReasonId"
            :items="remakeReasons"
            label="Remake Main Category"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Remake Main Category is required']"
          />
        </v-col>
      </v-row>

      <v-row v-if="(job && job.reference && job.reference.includes('REVISED')) || remakeSubReasonId">
        <v-col>
          <v-select
            v-model="remakeSubReasonId"
            :items="remakeSubReasons"
            label="Remake Sub Category"
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Remake Sub Category is required']"
          />
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    workOrder: null,
    remakeReasonId: null,
    remakeSubReasonId: null,
    job: null,
    remakeReasons: [],
    remakeSubReasons: [],
    remakeSubReasonsAll: [],
    loading: false,
  }),
  watch: {
    workOrder() {
      this.remakeSubReasonId = null;
      this.remakeReasonId = null;
      this.getJobs();
    },
    remakeReasonId() {
      this.remakeSubReasons = this.remakeSubReasonsAll.filter((x) => x.glass_remake_reason_id === this.remakeReasonId);
    },
  },
  created() {
    this.getRemakeReasons();
    this.getRemakeSubReasons();
  },
  methods: {

    async submit() {
      this.$bus.$emit('loading');
      const res = await this.$api.glassPurchaseOrderItem.get(`sync-manual/${this.workOrder}/${this.remakeReasonId}/${this.remakeSubReasonId}`);
      this.$bus.$emit('loading');

      if (res === '1000') {
        this.$bus.$emit('showError', 'Job does not exist');
        return false;
      }
      if (res === '1001') {
        this.$bus.$emit('showError', `Job ${this.workOrder} is already in the system`);
        return false;
      }
      if (res === '1002') {
        this.$bus.$emit('showError', 'Please perform SEND TO FPGEST to create PO for this job');
        return false;
      }

      if (res === '1003') {
        this.$bus.$emit('showError', 'Glass Code is not found');
        return false;
      }

      if (res === '1004') {
        this.$bus.$emit('showError', 'Job has no glass');
        return false;
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$emit('success');
      return res;
    },

    open() {
      this.$refs.dialogBox.open();
    },

    async getJobs() {
      this.loading = true;
      const submitModel = {
        filters: { inventory_class_id: this.inventoryClassId, work_order: this.workOrder },
      };
      const res = await this.$api.job.readDataSecondary(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res) {
        this.job = null;
        this.loading = false;
        return;
      }
      const firstIndex = 0;
      this.job = res[firstIndex];
      this.loading = false;
      if (this.job && this.job.reference) {
        const remakeSubReason = this.remakeSubReasonsAll.find((x) => this.job.reference.includes(x.code));
        if (remakeSubReason) {
          this.remakeSubReasonId = remakeSubReason.id;
          this.remakeReasonId = remakeSubReason.glass_remake_reason_id;
        }
      }
    },

    async getRemakeReasons() {
      const res = await this.$api.glassRemakeReason.get();
      this.remakeReasons = res.filter((x) => x.is_job === 1);
    },

    async getRemakeSubReasons() {
      this.remakeSubReasonsAll = await this.$api.glassRemakeSubReason.get();
    },
  },
};
</script>
